import React from "react";
import logoUrl from "@/assets/knowmeno-logo.png";

/**
 * KnowMeno wordmark — renders the official PNG logo.
 * Props preserved for backwards compatibility across the app.
 */
export function KnowMenoLogo({
  height = 40,
  tagline = false,
  invert = false,
  className,
  style,
}: {
  height?: number;
  tagline?: boolean;
  invert?: boolean;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        gap: tagline ? 6 : 0,
        ...style,
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "flex-start",
          lineHeight: 1,
        }}
      >
        <img
          src={logoUrl}
          alt="KnowMeno menopause tracking and insights"
          decoding="async"
          style={{
            height,
            width: "auto",
            display: "block",
            borderRadius: invert ? 6 : 0,
          }}
        />
        <span
          aria-hidden="true"
          style={{
            fontFamily: 'var(--font-ui, "Work Sans"), system-ui, sans-serif',
            fontSize: Math.max(7, height * 0.16),
            fontWeight: 500,
            color: invert ? "#FFFFFF" : "#6E4B73",
            marginLeft: Math.max(1, height * 0.03),
            marginTop: Math.max(1, height * 0.02),
            letterSpacing: 0,
            opacity: 0.7,
          }}
        >
          ™
        </span>
      </span>

      {tagline && (
        <span
          aria-hidden="true"
          style={{
            fontFamily:
              '"DM Serif Display","Playfair Display",Georgia,serif',
            fontSize: Math.max(10, height * 0.14),
            letterSpacing: "0.3em",
            color: invert ? "#FFFFFF" : "#4B1F4F",
          }}
        >
          KNOWLEDGE · SUPPORT · EMPOWERMENT
        </span>
      )}
    </span>
  );
}

export default KnowMenoLogo;
